export const isSuccessResponse = (response) =>
  response?.status !== undefined
  && response.status === 1;
